import { createContext, useContext } from "react";
import type { ArtifactTarget } from "../lib/artifact-open";

export type SitePreview = {
  target: ArtifactTarget;
  artifactId: string;
  name: string;
  mimeType: string;
  size: number;
};

export const SitePreviewContext = createContext<{
  preview: SitePreview | null;
  open: (preview: SitePreview, trigger: HTMLButtonElement | null) => void;
} | null>(null);

export function useSitePreview() {
  return useContext(SitePreviewContext);
}
